import { backdropClasses } from '@mui/material/Backdrop';
import type { Components, Theme } from '@mui/material/styles';

import { SHAPE, token } from './scales';

/** The kit overlays: menu items, tooltips, dialogs and the backdrop. */
export const OVERLAYS: Components<Theme> = {
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body1,
        marginInline: 4,
        borderRadius: SHAPE.small,
        color: theme.vars.palette.grey[700],
        '&:hover, &.Mui-focusVisible': { backgroundColor: theme.vars.palette.grey[100] },
      }),
    },
  },
  KitMenuItem: {
    variants: [
      {
        props: { destructive: true },
        style: ({ theme }) => ({
          color: theme.vars.palette.error.main,
          '&:hover, &.Mui-focusVisible': { backgroundColor: theme.vars.palette.tint.danger.fill },
        }),
      },
    ],
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        ...theme.typography.caption,
        maxWidth: 224,
        borderRadius: SHAPE.extraSmall,
        color: theme.vars.palette.grey[50],
        backgroundColor: theme.vars.palette.grey[900],
      }),
    },
  },
  MuiDialog: {
    styleOverrides: { paper: { borderRadius: SHAPE.extraLarge } },
  },
  MuiBackdrop: {
    styleOverrides: {
      root: { [`&:not(.${backdropClasses.invisible})`]: { backgroundColor: token('media-scrim', 0.5) } },
    },
  },
};
